import { Directive, HostListener, ElementRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appCeHours]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CeHoursDirective,
      multi: true
    }
  ]
})
export class CeHoursDirective implements Validator {

  constructor(private el: ElementRef) {}

  // Validator logic
  validate(control: AbstractControl): ValidationErrors | null {
    let value: string = control.value?.toString() || '';

    value = this.formatValue(value);

    if (control.value !== value) {
      control.setValue(value, { emitEvent: false });
    }

    return null; // always valid, just formatting
  }

  // Format on keyup/input
  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value || '';
    value = this.formatValue(value);
    this.el.nativeElement.value = value;
  }

  // Common formatter used by both validator & listener
  private formatValue(value: string): string {
  // Remove invalid characters (only digits and dot)
  value = value.replace(/[^0-9.]/g, '');

  // Allow only the first dot
  const firstDot = value.indexOf('.');
  if (firstDot !== -1) {
    value = value.slice(0, firstDot + 1) + value.slice(firstDot + 1).replace(/\./g, '');
  }

  let intPart = '';
  let fracPart = '';
  const hasDot = value.includes('.');

  if (hasDot) {
    [intPart, fracPart = ''] = value.split('.');
  } else {
    intPart = value;
  }

  // Restrict integer part to max 2 digits
  intPart = intPart.slice(0, 3);

  // Restrict fractional part to max 2 digits
  fracPart = fracPart.slice(0, 2);

  // Rebuild the value
  if (hasDot) {
    return intPart + '.' + fracPart;
  } else {
    return intPart;
  }
}
}
